/**
 * Import Tab Component
 *
 * Displays data import options:
 * - Connected Platforms card (platform sync)
 * - Upload File card (manual imports)
 */

import { Space } from 'antd'
import { ConnectedPlatformsCard } from './ConnectedPlatformsCard'
import { UploadFileCard } from './UploadFileCard'
import type { Connection } from '@/types/connection.types'
import type { InboundSyncConfig, OutboundSyncConfig } from '@/components/connections/ConnectionSyncStatusCard'

export interface ImportTabProps {
  /** Active connections */
  connections: Connection[]

  /** Loading state */
  loadingConnections?: boolean

  /** Inbound configs by connection uid */
  inboundConfigs?: Record<string, InboundSyncConfig>

  /** Outbound configs by connection uid */
  outboundConfigs?: Record<string, OutboundSyncConfig>

  /** Callback when "Sync Now" is clicked */
  onSyncNow?: (connectionUid: string) => void

  /** Callback when auto-activate toggle is changed */
  onToggleAutoActivate?: (connectionUid: string, value: boolean) => void
}

export function ImportTab({
  connections,
  loadingConnections,
  inboundConfigs,
  outboundConfigs,
  onSyncNow,
  onToggleAutoActivate,
}: ImportTabProps) {
  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      {/* Connected Platforms */}
      <ConnectedPlatformsCard
        connections={connections}
        loading={loadingConnections}
        inboundConfigs={inboundConfigs}
        outboundConfigs={outboundConfigs}
        onSyncNow={onSyncNow}
        onToggleAutoActivate={onToggleAutoActivate}
      />

      {/* Upload File */}
      <UploadFileCard />
    </Space>
  )
}
